// NEEDED TO FEED PREQGENERATOR ITS PARAMS

import PreQLetterGenerator from "./PreQLetterGenerator";
import { useParams } from "react-router";
export default function PreQLetterDownloader() {
  const params = useParams();
  return <PreQLetterGenerator preQId={params.preQId} />;
}
